// Where is the cat? At home, or away in one place (Capital City or a land). Only one place at a time. The Capital scene
// and the land scene both report here; the RETURN HOME button, the locked rail buttons and the "can I go?" checks read it.
import { Events, emit } from '../ui/eventBus.js'

let away = { id: null, active: false, busy: false }

export const getAway = () => away
export const isAwayBusy = () => away.active || away.busy // travelling there, there, or travelling back

// A scene calls this whenever its own state changes (id = its place; active = arrived; busy = travelling in either direction).
export function setAway(id, { active = false, busy = false } = {}) {
  if (!active && !busy) { if (away.id !== id) return; away = { id: null, active: false, busy: false } } // only the place we're in can clear it
  else away = { id, active: !!active, busy: !!busy }
  emit(Events.AwayChange, { ...away })
}

// "Take me home": whichever place we are in answers (the other ignores it).
export function leaveAway() {
  emit(Events.LeaveCapital)
  emit(Events.LeaveLand)
}
